(() => {
  if (window.sikVolumeTwoPurchaseLoaded) return;
  window.sikVolumeTwoPurchaseLoaded = true;
  const initialise = root => {
    if (root.dataset.sikPurchaseReady) return;
    root.dataset.sikPurchaseReady = 'true';
    const gallery = root.querySelector('[data-sik-purchase-gallery]');
    if (gallery) {
      const mainImage = gallery.querySelector('[data-sik-purchase-gallery-image]');
      const galleryButtons = Array.from(gallery.querySelectorAll('[data-sik-purchase-gallery-button]'));
      const controls = gallery.querySelector('[data-sik-purchase-gallery-controls]');
      if (mainImage && controls && galleryButtons.length) {
        galleryButtons.forEach(button => button.addEventListener('click', () => {
          mainImage.src = button.dataset.imageSrc;
          mainImage.alt = button.dataset.imageAlt;
          galleryButtons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        }));
        controls.hidden = false;
      }
    }
    const variants = Array.from(root.querySelectorAll('[data-sik-purchase-variant]'));
    const submit = root.querySelector('[data-sik-purchase-submit]');
    const quantity = root.querySelector('[data-sik-purchase-quantity]');
    if (!variants.length || !submit || !quantity) return;
    const price = root.querySelector('[data-sik-purchase-price]');
    const unit = root.querySelector('[data-sik-purchase-unit]');
    const saving = root.querySelector('[data-sik-purchase-saving]');
    const availability = root.querySelector('[data-sik-purchase-availability]');
    const sync = () => {
      const option = variants.find(variant => variant.checked);
      if (!option) { submit.disabled = true; return; }
      const available = option.dataset.available === 'true';
      price.textContent = option.dataset.price;
      unit.textContent = option.dataset.unit;
      unit.hidden = !option.dataset.unit;
      saving.textContent = option.dataset.saving;
      saving.hidden = !option.dataset.saving;
      submit.disabled = !available;
      root.querySelector('[data-sik-purchase-submit-label]').textContent = available ? submit.dataset.availableLabel : submit.dataset.unavailableLabel;
      availability.textContent = available ? availability.dataset.availableLabel : availability.dataset.unavailableLabel;
      const minimum = Number(option.dataset.min) || 1;
      const increment = Number(option.dataset.step) || 1;
      quantity.min = String(minimum);
      quantity.step = String(increment);
      if (option.dataset.max) quantity.max = option.dataset.max;
      else quantity.removeAttribute('max');
      const current = Number(quantity.value);
      if (!Number.isInteger(current) || current < minimum || (current - minimum) % increment !== 0 || (quantity.max && current > Number(quantity.max))) quantity.value = String(minimum);
    };
    const requestedVariant = new URLSearchParams(location.search).get('variant');
    const requestedOption = variants.find(option => option.value === requestedVariant);
    if (requestedOption) requestedOption.checked = true;
    variants.forEach(option => option.addEventListener('change', sync));
    sync();
  };
  const start = (scope = document) => {
    if (scope.matches?.('[data-sik-v2-purchase]')) initialise(scope);
    scope.querySelectorAll('[data-sik-v2-purchase]').forEach(initialise);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(), { once: true });
  else start();
  document.addEventListener('shopify:section:load', event => start(event.target));
})();
